import { GridRow } from '@mui/x-data-grid';
import type { GetContractsOverviewsResponse } from '@weft/api-definition';
import type { ItemOf } from '@weft/utils';
import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import type { VyTableMinimalProps } from '../../../../components/new-design/table/vy-table/VyTable';
import { VyTable } from '../../../../components/new-design/table/vy-table/VyTable';
import { CONTRACTS_COLUMNS } from '../plans-page-consts/contracts-columns';

export const ContractsTable: React.FC<
VyTableMinimalProps<ItemOf<GetContractsOverviewsResponse['contracts']>>
> = ({ itemsCount, items, loadingItems }) => {
  const columns = useMemo(() => CONTRACTS_COLUMNS, []);

  return (
    <>
      <VyTable
        itemsCount={itemsCount}
        items={items}
        loadingItems={loadingItems}
        columns={columns}
        slots={{
          row: (rowProps) => (
            <NavLink
              onClick={(event: React.MouseEvent<HTMLAnchorElement> & { ignore?: boolean }) => {
                event.ignore && event.preventDefault();
              }}
              to={`contracts/${rowProps.row.id}`}
            >
              <GridRow {...rowProps} />
            </NavLink>
          ),
        }}
        sx={{
          paddingBottom: '150px',
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: 'createdAt',
                sort: 'desc',
              },
            ],
          },
        }}
      />
    </>
  );
};
